<template>
  <div class="container">
    <content-header :data="[{text:'小程序首页图片轮播设置', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <el-button type="primary" icon="plus" @click="initNewHandle">添加</el-button>
      </div>
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            label="图片">
            <template slot-scope="scope">
            <img style="width:50px;height:50px":src="domainPic + scope.row.imageUrl" />
            </template>
          </el-table-column>
          <el-table-column
            label="关联类型">
            <template slot-scope="scope">
              <span>{{scope.row.targetType==1 ? '商品' : '商品分类'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="targetId"
            label="关联对象ID">
          </el-table-column>
          <el-table-column
            prop="description"
            label="关联对象">
          </el-table-column>
          <el-table-column
            prop="dateUpdated"
            label="发布日期">
          </el-table-column>
          <el-table-column
            label="操作"
            width="120">
            <template slot-scope="scope">
              <el-button @click="initEditHandle(scope)" type="text" size="small">修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="new-wrap">
        <el-dialog :title="curObj.id ? '修改图片轮播' : '添加图片轮播'" width="50%" :visible.sync="isObjShow">
          <el-form :model="curObj" :rules="curObjRules" ref="curObjForm">
            <el-form-item prop="imageUrl" label="图片" :label-width="formLabelWidth">
              <el-upload
                class="avatar-uploader"
                action="//upload-z2.qiniup.com"
                :data="uploadForm"
                :show-file-list="false"
                :on-success="uploadPhotoSuccess"
                :before-upload="beforePhotoUpload"
                :on-error="uploadError">
                <img v-if="curObj.imageUrl" :src="domainPic + curObj.imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item prop="targetType" label="关联类型" :label-width="formLabelWidth">
              <el-select v-model="curObj.targetType" value-key="id" placeholder="请选择">
                <el-option
                  v-for="item in targetTypeOpts"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <template v-if="curObj.targetType == 4">
              <el-form-item prop="targetId" label="选择分类" :label-width="formLabelWidth">
                <el-cascader
                  expand-trigger="hover"
                  :options="categoryOpts"
                  :props="defaultProp"
                  :show-all-levels="false"
                  v-model="curObj.targetValue"
                  change-on-select
                  @change="handleCategoryChange"
                ></el-cascader>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item prop="targetId" label="选择商品" :label-width="formLabelWidth">
                <el-select v-model="curObj.targetId" value-key="id" filterable placeholder="请选择"
                @change="handleProductChange"
                >
                  <el-option
                    v-for="item in productOpts"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isObjShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>

          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import constants from 'config/constants'
  import date from 'utils/date'
  import { mapState } from 'vuex'
  import MarketingModel from 'models/marketing'
  import CategoryModel from 'models/category'
  import CommonModel from 'models/common'
  import ProductModel from 'models/product'

  export default {
    data () {
      return {
        domainPic: constants.basic.domain_pic,
        tableData: [],
        targetTypeOpts: [{id: 1, name: '商品'}, {id: 4, name: '商品分类'}],
        curObj: {
          id: '',
          title: '',
          description: '',
          imageUrl: '',
          targetId: '',
          targetType: 4,
          targetValue: [],
          sequence: 3
        },
        curObjRules: {
          imageUrl: [{ required: true, message: '请上传图片', trigger: 'blur' }],
          targetType: [{ required: true, message: '请选择关联类型', trigger: 'blur' }],
          targetId: [{ required: true, message: '请选择关联对象', trigger: 'blur' }],
        },
        isObjShow: false,
        formLabelWidth: '80px',
        categoryOpts: [],
        defaultProp: {
          children: 'child',
          label: 'name',
          value: 'id'
        },
        //
        uploadForm: {key: '', token: ''},
        qiniuHost: '',
        //
        productOpts: [],
      }
    },
    created () {
      this.getObjList()
      CategoryModel.find().then(res => {
        let tmpTree = {id: '', name: '', child: res.category_tree}
        removeEmptyChild(tmpTree)

        function removeEmptyChild (node) {
          if (node != null) {
            if (node.child.length === 0) {
              delete node.child
            } else {
              let childrens = node.child
              for (let i = 0; i < childrens.length; i++) {
                removeEmptyChild(childrens[i])
              }
            }
          }
        }
        this.categoryOpts = tmpTree.child
      })
      //
      ProductModel.find({curPage: 1, pageSize: 1000}).then(res => {
        this.productOpts = res.rows
      })
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.info
      }),
    },
    methods: {
      //
      uploadRemove (file, fileList) {
        console.log(file)
      },
      uploadError (err, file, fileList) {
        console.log(err)
      },
      uploadExceed (files, fileList) {
        console.log(files.length)
      },
      uploadPhotoSuccess (response, file, fileList) {
        // console.log(response)
        this.curObj.imageUrl = response.key
      },
      beforePhotoUpload (file) {
        const isPic = (file.type === 'image/jpeg' || file.type === 'image/png')
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isPic) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
          return false
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
          return false
        }
        //
        if (!this.uploadForm.token) {
          return CommonModel.getQiniuUptoken().then(res => {
            this.qiniuHost = res.qiniuHost
            this.uploadForm.token = res.uptoken
            let curr = date(new Date().getTime(), 'yyyyMMdd')
            let prefix = 'marketing'
            let suffix = file.name
            this.uploadForm.key = encodeURI(`${curr}/${prefix}_${suffix}`)
            console.log(this.uploadForm)
          })
        } else {
          let curr = date(new Date().getTime(), 'yyyyMMdd')
          let prefix = 'marketing'
          let suffix = file.name
          this.uploadForm.key = encodeURI(`${curr}/${prefix}_${suffix}`)
          console.log(this.uploadForm)
        }
        return true
      },
      getObjList () {
        MarketingModel.findClientHomeFeatured({businessType: 1}).then(res => {
          // console.log(res)
          for (let i = 0; i < res.length; i++) {
            res[i].imageUrl = JSON.parse(res[i].appImg).media
          }
          this.tableData = res
        })
      },
      //
      deleteHandle (item) {
        this.$confirm('是否确认删除？')
          .then(_ => {
            MarketingModel.deleteClientHomeFeatured({
              id: item.row.id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          if (this.curObj.id) return this.editHandle()
          this.newHandle()
        })
      },
      initNewHandle () {
        this.curObj = {
          id: '',
          title: '',
          description: '',
          imageUrl: '',
          sequence: 3,
          targetId: '',
          targetType: 4,
          targetValue: []
        }
        this.isObjShow = true
      },
      newHandle () {
        MarketingModel.createClientHomeFeatured({
          title: this.curObj.title,
          description: this.curObj.description,
          targetId: this.curObj.targetId,
          targetType: this.curObj.targetType,
          sequence: this.curObj.sequence,
          businessType: 1,
          appImg: JSON.stringify({media: this.curObj.imageUrl, type: 1})

        }).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      initEditHandle (item) {
        this.curObj = {
          id: item.row.id,
          title: item.row.title,
          description: item.row.description,
          targetId: item.row.targetId,
          targetType: item.row.targetType,
          sequence: item.row.sequence,
          imageUrl: item.row.imageUrl,
        }
        let targetValue = []
        for (let i = 0; i < this.categoryOpts.length; i++) {
          if (findTargetValue(this.categoryOpts[i], this.curObj.targetId, targetValue)) {
            break
          }
        }
        this.curObj.targetValue = targetValue

        console.log(this.curObj)

        function findTargetValue (node, id, targetValue) {
          if (node != null) {
            // console.log(targetValue)
            // console.log(node.id)
            targetValue.push(node.id)
            if (node.id === id) {
              // console.log('found======')
              return true
            } else {
              if (node.hasOwnProperty('child')) {
                for (let i = 0; i < node.child.length; i++) {
                  let found = findTargetValue(node.child[i], id, targetValue)
                  if (found) {
                    return true
                  }
                }
                targetValue.pop()
                return false
              } else {
                targetValue.pop()
                return false
              }
            }
          }
        }
        this.isObjShow = true
      },
      editHandle () {
        MarketingModel.updateClientHomeFeatured({
          id: this.curObj.id,
          title: this.curObj.title,
          description: this.curObj.description,
          targetId: this.curObj.targetId,
          targetType: this.curObj.targetType,
          sequence: this.curObj.sequence,
          businessType: 1,
          appImg: JSON.stringify({media: this.curObj.imageUrl, type: 1})
        }).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      //
      handleCategoryChange (value) {
        console.log(value)
        this.curObj.targetId = value[value.length - 1]
        let tmpTree = {id: '', name: '', child: this.categoryOpts}
        this.curObj.title = findNodeName(tmpTree, this.curObj.targetId)
        this.curObj.description = this.curObj.title

        function findNodeName (node, id) {
          if (node != null) {
            if (node.id === id) {
              return node.name
            } else {
              if (node.hasOwnProperty('child')) {
                for (let i = 0; i < node.child.length; i++) {
                  let name = findNodeName(node.child[i], id)
                  if (name !== '') {
                    return name
                  }
                }
                return ''
              } else {
                return ''
              }
            }
          } else {
            return ''
          }
        }
        // console.log(this.curObj)
      },
      handleProductChange (value) {
        console.log(value)
        this.curObj.title = this.productOpts.find(item => item.id === value).name
        this.curObj.description = this.curObj.title
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
    .new-wrap
      .el-input
        width: 85%
      .avatar-uploader
          border: 1px dashed #d9d9d9
          border-radius: 6px
          cursor: pointer
          position: relative
          overflow: hidden
          width: 180px
          &:hover
            border-color: #409EFF
          .avatar-uploader-icon
            font-size: 28px
            color: #8c939d
            width: 180px
            height: 90px
            line-height: 90px
            text-align: center
          .avatar
            width: 180px
            height: 90px
            display: block
</style>



// WEBPACK FOOTER //
// src/views/HomeBanner.vue